import { QuestionnaireItem } from '@app/questionnaire/components/item/QuestionnaireItem';

export const ParentQuestionnairePage = () => {
  return <QuestionnaireItem />;
};
